import { render, staticRenderFns } from "./customSelect.vue?vue&type=template&id=0cb00dd3&scoped=true&"
import script from "./customSelect.vue?vue&type=script&lang=js&"
export * from "./customSelect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cb00dd3",
  null
  
)

export default component.exports